import { render, staticRenderFns } from "./ProgramDownloads.vue?vue&type=template&id=1a827ee4&"
import script from "./ProgramDownloads.vue?vue&type=script&lang=js&"
export * from "./ProgramDownloads.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDownloads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports